import React, { useState, useCallback } from "react";
import ImageViewer from "react-simple-image-viewer";
import PropTypes from "prop-types";
import {Grid} from "@mui/material";
import CardMedia from "@mui/material/CardMedia";

export default function ProductImageViewer(props) {
    const [currentImage, setCurrentImage] = useState(0);
    const [isViewerOpen, setIsViewerOpen] = useState(false);

    const openImageViewer = useCallback((index) => {
        setCurrentImage(index);
        setIsViewerOpen(true);
    }, []);

    const closeImageViewer = () => {
        setCurrentImage(0);
        setIsViewerOpen(false);
    };
    return (
        <>
            <Grid container>
                <Grid item sm={3} xs={12} sx={{ order: { xs: 2, sm: 1 } }}>
                    <div className="imageViewer-other">
                        {props.images.map((src, index) => (
                            <div key={`imageViewer-other_${index}`}>
                                <img
                                    src={src}
                                    onClick={() => openImageViewer(index)}
                                    alt=""
                                />
                            </div>
                        ))}
                    </div>
                </Grid>

                <Grid item sm={9} xs={12} sx={{ order: { xs: 1, sm: 2 } }}>
                    <div className="imageViewer-main">
                        {props.children}
                        <img
                            src={props.images[0]}
                            onClick={() => openImageViewer(0)}
                            key={0}
                            alt=""
                        />
                    </div>
                </Grid>



            </Grid>
            {isViewerOpen && (
                <ImageViewer
                    src={props.images}
                    currentIndex={currentImage}
                    onClose={closeImageViewer}
                    disableScroll={false}
                    backgroundStyle={{
                        backgroundColor: "rgba(0,0,0,0.9)"
                    }}
                    closeOnClickOutside={true}
                />
            )}
        </>
    );
}

ProductImageViewer.propTypes = {
    images: PropTypes.array.isRequired
};